export default __webpack_public_path__ + "static/media/IMG-20240822-WA0015.dbfabfc7.jpg";